import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { mangaList } from "@/mocks/manga";

const featured = mangaList.filter((m) => ["shenye-shitang", "yingluo-zhizheng", "fengqi-shanhai"].includes(m.id));

export default function FeaturedSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <SectionHeading
          eyebrow="编辑精选"
          title="本周编辑推荐"
          desc="我们的编辑团队每周从口碑、题材与独特性出发，为你挑选值得细品的作品。"
        />
        <Link
          to="/manga"
          className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
        >
          查看全部
          <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
        {featured.map((m, i) => (
          <Link
            key={m.id}
            to={`/manga/${m.id}`}
            className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-100"
          >
            <div className="relative h-56 overflow-hidden md:h-64">
              <img
                src={m.cover}
                alt={`${m.title}漫画封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <span className="absolute left-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-base font-bold text-background-50">
                {i + 1}
              </span>
            </div>
            <div className="relative -mt-10 px-5 pb-6">
              <h3 className="font-heading text-xl font-bold text-background-50 group-hover:text-accent-300">
                {m.title}
              </h3>
              <p className="mt-1 text-xs text-background-100/85">
                {m.author} · {m.genre} · 评分 {m.rating}
              </p>
              <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-800">
                {m.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}